import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { "element-loading-background": "rgba(122, 122, 122, 0.3)" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = { style: {"text-decoration":"underline"} }
const _hoisted_4 = { class: "fs-5 mt-4" }
const _hoisted_5 = { class: "row row-cols-12" }
const _hoisted_6 = { class: "col col-3" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold me-2" }, "Name:", -1)
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col col-3" }
const _hoisted_10 = { class: "fw-bold me-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "col col-6" }
const _hoisted_13 = { class: "fw-bold me-2" }
const _hoisted_14 = { class: "row row-cols-12" }
const _hoisted_15 = { class: "col col-3" }
const _hoisted_16 = { class: "fw-bold me-2" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "col col-3" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold me-2" }, /*#__PURE__*/_toDisplayString("Comment Code") + ":", -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "col" }
const _hoisted_22 = { class: "fw-bold me-2" }
const _hoisted_23 = { class: "row row-cols-12" }
const _hoisted_24 = { class: "col col-3" }
const _hoisted_25 = { class: "fw-bold me-2" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { class: "col col-3" }
const _hoisted_28 = { class: "fw-bold me-2" }
const _hoisted_29 = { key: 0 }
const _hoisted_30 = { class: "col" }
const _hoisted_31 = { class: "fw-bold me-2" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold me-2" }, "Logo", -1)
const _hoisted_35 = ["src"]
const _hoisted_36 = { key: 1 }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("p", { class: "fw-bold me-2" }, "Logo", -1)

import { inject, onMounted, ref, watch, nextTick } from "vue";
import LoadingRing from "@/components/LoadingRing.vue";
import NoDataBox from "@/components/NoDataBox.vue";
import PaymentService from "../services/PaymentService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
// import { useStore } from "@/store";
import { CurrencyTypes } from "@/core/types/CurrencyTypes";
import tenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import UploadImage from "../components/UploadImage.vue";
// const store = useStore();

export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentServiceInfo',
  props: {
    paymentServiceId: {},
    sortedServices: {},
    closeFunction: { type: Function }
  },
  emits: ["update"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const availableCurrenciesOptions = ref([
  { label: "AUD", value: CurrencyTypes.AUD },
  { label: "USD", value: CurrencyTypes.USD },
  { label: "CNY/RMB", value: CurrencyTypes.CNY },
  { label: "VND", value: CurrencyTypes.VND },
  { label: "THB", value: CurrencyTypes.THB },
  { label: "IDR", value: CurrencyTypes.IDR },
  { label: "PHP", value: CurrencyTypes.PHP },
  { label: "MYR", value: CurrencyTypes.MYR },
  { label: "HKD", value: CurrencyTypes.HKD },
  { label: "JPY", value: CurrencyTypes.JPY },
]);
const isLoading = ref(true);
const serviceDetail = ref({} as any);
const editMode = ref(false);
const uploadImageRef = ref<any>(null);


const fetchData = async () => {
  isLoading.value = true;
  try {
    serviceDetail.value = await PaymentService.getPaymentMethodById(
      props.paymentServiceId
    );
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

const updatePayment = async () => {
  openConfirmBox?.(
    async () => {
      isLoading.value = true;
      // await PaymentService.putPaymentMethodByIdV2(props.paymentServiceId, {
      //   ...serviceDetail.value,
      // });

      // 如果logo有更新，則上傳圖片
      if (serviceDetail.value.logo !== uploadImageRef.value.imageUrl) {
        await uploadImageRef.value.uploadImage().then(() => {
          const res = uploadImageRef.value.imageUrl;
          if (res[0] != undefined) {
            serviceDetail.value.logo = res[0];
          }
        });
      }

      await PaymentService.updatePaymentMethodDetailById(
        props.paymentServiceId,
        {
          ...serviceDetail.value,
        }
      );

      serviceDetail.value = await PaymentService.getPaymentMethodById(
        props.paymentServiceId
      );

      emits("update");
      isLoading.value = false;
      editMode.value = false;
    },
    () => void 0,
    {
      confirmText: "Are you sure to update the payment service?",
    }
  );
};

const openConfirmBox = inject(tenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);

watch(
  () => editMode.value,
  async (newVal) => {
    if (newVal === true) {
      await nextTick();
      uploadImageRef.value.imageUrl = serviceDetail.value.logo;
    }
  },
  { immediate: true }
);

onMounted(async () => {
  await fetchData();
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_checkbox_group = _resolveComponent("el-checkbox-group")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", _hoisted_3, " Payment Service Detail: " + _toDisplayString(serviceDetail.value.name), 1),
      _createElementVNode("div", null, [
        (!editMode.value)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (editMode.value = true)),
              type: "primary",
              plain: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode("Edit")
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_el_button, {
                type: "success",
                plain: "",
                onClick: updatePayment
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Save")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (editMode.value = false)),
                plain: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Cancel")
                ]),
                _: 1
              })
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("p", _hoisted_6, [
          _hoisted_7,
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(serviceDetail.value.name), 1))
            : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: serviceDetail.value.name,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((serviceDetail.value.name) = $event)),
                class: "w-150px"
              }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t("fields.category")) + ":", 1),
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(serviceDetail.value.group), 1))
            : (_openBlock(), _createBlock(_component_el_select, {
                key: 1,
                class: "w-150px",
                modelValue: serviceDetail.value.group,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((serviceDetail.value.group) = $event)),
                placeholder: _ctx.$t('fields.category')
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedServices, (value, index) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: index,
                      label: index,
                      value: index
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue", "placeholder"]))
        ]),
        _createElementVNode("p", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("fields.availableCurrencies")) + ":", 1),
          (!editMode.value)
            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(serviceDetail.value.availableCurrencies, (currency) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: currency,
                  class: "me-2"
                }, _toDisplayString(_ctx.$t(`type.currency.${currency}`)), 1))
              }), 128))
            : (_openBlock(), _createBlock(_component_el_checkbox_group, {
                key: 1,
                modelValue: serviceDetail.value.availableCurrencies,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((serviceDetail.value.availableCurrencies) = $event))
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCurrenciesOptions.value, (currency) => {
                    return (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: currency.value,
                      label: currency.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(currency.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("p", _hoisted_15, [
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("fields.activate")) + ":", 1),
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(serviceDetail.value.status ? "Yes" : "No"), 1))
            : (_openBlock(), _createBlock(_component_el_select, {
                key: 1,
                class: "w-75px",
                modelValue: serviceDetail.value.status,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((serviceDetail.value.status) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_option, {
                    label: "Yes",
                    value: 10
                  }),
                  _createVNode(_component_el_option, {
                    label: "No",
                    value: 0
                  })
                ]),
                _: 1
              }, 8, ["modelValue"]))
        ]),
        _createElementVNode("p", _hoisted_18, [
          _hoisted_19,
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(serviceDetail.value.commentCode), 1))
            : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                modelValue: serviceDetail.value.commentCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((serviceDetail.value.commentCode) = $event)),
                class: "w-50px"
              }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("p", _hoisted_21, [
          _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("fields.currency")) + ":", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t(`type.currency.${serviceDetail.value.currencyId}`)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("p", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t("fields.initMinAmount")) + ":", 1),
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(serviceDetail.value.initialValue), 1))
            : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                class: "w-75px",
                type: "number",
                modelValue: serviceDetail.value.initialValue,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((serviceDetail.value.initialValue) = $event))
              }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("p", _hoisted_27, [
          _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("fields.minAmount")) + ":", 1),
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(serviceDetail.value.minValue), 1))
            : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                class: "w-75px",
                type: "number",
                modelValue: serviceDetail.value.minValue,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((serviceDetail.value.minValue) = $event))
              }, null, 8, ["modelValue"]))
        ]),
        _createElementVNode("p", _hoisted_30, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t("fields.maxAmount")) + ":", 1),
          (!editMode.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(serviceDetail.value.maxValue), 1))
            : (_openBlock(), _createBlock(_component_el_input, {
                key: 1,
                class: "w-75px",
                type: "number",
                modelValue: serviceDetail.value.maxValue,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((serviceDetail.value.maxValue) = $event))
              }, null, 8, ["modelValue"]))
        ])
      ]),
      (!editMode.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
            _hoisted_34,
            _createElementVNode("div", null, [
              (serviceDetail.value.logo)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    src: serviceDetail.value.logo,
                    class: "w-175px border border-2"
                  }, null, 8, _hoisted_35))
                : (_openBlock(), _createElementBlock("div", _hoisted_36, "No Logo Uploaded"))
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _hoisted_38,
            _createVNode(UploadImage, {
              ref_key: "uploadImageRef",
              ref: uploadImageRef
            }, null, 512)
          ]))
    ])
  ])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})